import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { AuthProvider } from "@/auth/AuthContext";
import HomePage from "@/pages/HomePage";
import SuccessPage from "@/pages/SuccessPage";
import PricingPage from "@/pages/PricingPage";
import BookingPage from "@/pages/BookingPage";
import LetterPage from "@/pages/LetterPage";
import MyLettersPage from "@/pages/MyLettersPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import PatientAreaPage from "@/pages/PatientAreaPage";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/pricing" element={<PricingPage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/success" element={<SuccessPage />} />
              <Route path="/le-mie-lettere" element={<MyLettersPage />} />
              <Route path="/lettera/:letterId" element={<LetterPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/area-paziente" element={<PatientAreaPage />} />
            </Routes>
          </BrowserRouter>
        <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
